<script setup lang="ts">
import type { FilterOption } from '@/types/filter.types'
import LiveStreamingList from './LiveStreamingList.vue'
import OnlineClassList from './OnlineClassList.vue'

// props로 현재 선택된 필터 받기
const props = defineProps<{
  selectedCategory: FilterOption
}>()
</script>

<template>
  <div class="online-class-list-section">
    <!-- 라이브 스트리밍 표시 -->
    <LiveStreamingList v-if="props.selectedCategory.data === 'live-streaming'" />

    <!-- 온라인 클래스 표시 -->
    <OnlineClassList v-else />
  </div>
</template>

<style scoped>
.online-class-list-section {
  width: 100%;
}
</style>
